import * as types from "./constant"

// add policy-type
export const addPolicyTypeStart = payload => {
  return {
    type: types.ADD_POLICY_TYPE_START,
    payload,
  }
}

export const addPolicyTypeSuccess = payload => {
  return {
    type: types.ADD_POLICY_TYPE_SUCCESS,
    payload,
  }
}

export const getEnumValueSuccess = payload => {
  return {
    type: types.GET_ENUM_VALUE,
    payload,
  }
}

export const getEnumValueReset = () => {
  return {
    type: types.RESET_ENUM_VALUE,
  }
}

export const addPolicyTypeFailure = error => ({
  type: types.ADD_POLICY_TYPE_FAILURE,
  payload: error,
})

export const addPolicyTypeReset = () => ({
  type: types.ADD_POLICY_TYPE_RESET,
})

// view - policy

export const viewPolicyTypeStart = () => {
  return {
    type: types.VIEW_POLICY_TYPE_START,
  }
}

export const viewPolicyTypeSuccess = payload => {
  return {
    type: types.VIEW_POLICY_TYPE_SUCCESS,
    payload,
  }
}

export const viewPolicyTypeFailure = error => ({
  type: types.VIEW_POLICY_TYPE_FAILURE,
  payload: error,
})

export const viewPolicyTypeReset = () => ({
  type: types.VIEW_POLICY_TYPE_FAILURE,
})

// policy for customer

// add policy-type
export const addPolicyStart = payload => {
  return {
    type: types.ADD_POLICY_START,
    payload,
  }
}

export const addPolicySuccess = payload => {
  return {
    type: types.ADD_POLICY_SUCCESS,
    payload,
  }
}

export const addPolicyFailure = error => ({
  type: types.ADD_POLICY_FAILURE,
  payload: error,
})

export const addPolicyReset = () => ({
  type: types.ADD_POLICY_RESET,
})

// get policy for customer

export const getPolicyStart = payload => {
  return {
    type: types.GET_POLICY_CUSTOMER_START,
    payload,
  }
}

export const getPolicySuccess = payload => {
  return {
    type: types.GET_POLICY_CUSTOMER_SUCCESS,
    payload,
  }
}

export const getPolicyFailure = error => ({
  type: types.GET_POLICY_CUSTOMER_FAILURE,
  payload: error,
})

export const getPolicyReset = () => ({
  type: types.GET_POLICY_CUSTOMER_RESET,
})

// get policy by customer id

export const getPolicyIdStart = payload => {
  return {
    type: types.GET_POLICY_CUSTOMER_ID_START,
    payload,
  }
}

export const getPolicyIdSuccess = payload => {
  return {
    type: types.GET_POLICY_CUSTOMER_ID_SUCCESS,
    payload,
  }
}

export const getPolicyIdFailure = error => ({
  type: types.GET_POLICY_CUSTOMER_ID_FAILURE,
  payload: error,
})

export const getPolicyIdReset = () => ({
  type: types.GET_POLICY_CUSTOMER_ID_RESET,
})

// Update policy status

export const updatePolicyStart = payload => {
  return {
    type: types.UPDATE_POLICY_START,
    payload,
  }
}

export const updatePolicySuccess = payload => {
  return {
    type: types.UPDATE_POLICY_SUCCESS,
    payload,
  }
}

export const updatePolicyFailure = error => ({
  type: types.UPDATE_POLICY_FAILURE,
  payload: error,
})

export const updatePolicyReset = () => ({
  type: types.UPDATE_POLICY_RESET,
})

// Get company name

export const getCompanyStart = payload => {
  return {
    type: types.GET_Company_START,
    payload,
  }
}

export const getCompanySuccess = payload => {
  return {
    type: types.GET_Company_SUCCESS,
    payload,
  }
}

export const getCompanyFailure = error => ({
  type: types.GET_Company_FAILURE,
  payload: error,
})

export const getCompanyReset = () => ({
  type: types.GET_Company_RESET,
})

// Get Policy Name

export const getPolicyNameStart = () => {
  return {
    type: types.GET_POLICY_START,
  }
}

export const getPolicyNameSuccess = payload => {
  return {
    type: types.GET_POLICY_SUCCESS,
    payload,
  }
}

export const getPolicyNameFailure = error => ({
  type: types.GET_POLICY_FAILURE,
  payload: error,
})

export const getPolicyNameReset = () => ({
  type: types.GET_POLICY_RESET,
})

// Sub-Policies

export const getSubPolicyNameStart = payload => {
  return {
    type: types.GET_SUB_POLICY_START,
    payload: payload,
  }
}

export const getSubPolicyNameSuccess = payload => {
  return {
    type: types.GET_SUB_POLICY_SUCCESS,
    payload,
  }
}

export const getSubPolicyNameFailure = error => ({
  type: types.GET_SUB_POLICY_FAILURE,
  payload: error,
})

export const getSubPolicyNameReset = () => ({
  type: types.GET_SUB_POLICY_RESET,
})

// Get Sub LOB
export const getSubLobStart = payload => {
  return {
    type: types.GET_SUB_LOB_START,
    payload: payload,
  }
}

export const getSubLobSuccess = payload => {
  return {
    type: types.GET_SUB_LOB_SUCCESS,
    payload,
  }
}

export const getSubLobFailure = error => ({
  type: types.GET_SUB_POLICY_FAILURE,
  payload: error,
})

export const getSubLobReset = () => ({
  type: types.GET_SUB_POLICY_RESET,
})

// Policy Linking Action

export const PolicyLinkingStart = payload => {
  return {
    type: types.POLICY_LINKING_START,
    payload,
  }
}

export const PolicyLinkingSuccess = error => ({
  type: types.POLICY_LINKING_SUCCESS,
  payload: error,
})

export const PolicyLinkingFailure = () => ({
  type: types.POLICY_LINKING_FAILURE,
})

export const PolicyLinkingReset = () => ({
  type: types.POLICY_LINKING_RESET,
})

//

export const getProductNameStart = payload => ({
  type: types.GET_RRODUCT_START,
  payload: payload,
})

export const getProductNameSuccess = payload => ({
  type: types.GET_RRODUCT_SUCCESS,
  payload: payload,
})

export const getProductNameFailure = error => ({
  type: types.GET_RRODUCT_FAILURE,
  payload: error,
})

export const getProductNameReset = () => ({
  type: types.GET_RRODUCT_FAILURE,
})

// gst action

export const getGSTStart = () => ({
  type: types.GET_GST_START,
})

export const getGSTSuccess = (payload) => ({
  type: types.GET_GST_SUCCESS,
  payload
})

export const getGSTFailure = (payload) => ({
  type: types.GET_GST_FAILURE,
  payload
})

export const getGSTReset = () => ({
  type: types.GET_GST_RESET,
})

// Get Additional LOB fields
export const getAdditionalLobStart = payload => ({
  type: types.GetAdditionalLOB_START,
  payload: payload,
})

export const getAdditionalLobSuccess = payload => ({
  type: types.GetAdditionalLOB_SUCCESS,
  payload: payload,
})

export const getAdditionalLobFailure = error => ({
  type: types.GetAdditionalLOB_FAILURE,
  payload: error,
})

export const getAdditionalLobReset = () => ({
  type: types.GetAdditionalLOB_RESET,
})

//
export const setIsBharatReg = isBharatReg => ({
  type: types.SET_IS_BHARAT_REG,
  payload: isBharatReg,
})

export const setIsNcb = isNcb => ({
  type: types.SET_IS_NCB,
  payload: isNcb,
})

export const ResetBharatandNCB = () => ({
  type: types.RESET_BHARAT_REG_NCB,
})

// Get State  types.RESET_NCB &&

export const getStateStart = () => ({
  type: types.GET_STATE_START,
})
export const getStateSuccess = payload => ({
  type: types.GET_STATE_SUCCESS,
  payload: payload,
})

export const getStateFailure = error => ({
  type: types.GET_STATE_FAILURE,
  payload: error,
})
export const getStateReset = () => ({
  type: types.GET_STATE_RESET,
})

// Get Registration

export const getRegStart = payload => ({
  type: types.GET_REG_START,
  payload: payload,
})
export const getRegSuccess = payload => ({
  type: types.GET_REG_SUCCESS,
  payload: payload,
})

export const getRegFailure = error => ({
  type: types.GET_REG_FAILURE,
  payload: error,
})
export const getRegReset = () => ({
  type: types.GET_REG_RESET,
})

// BRAND NAME
export const getBrandStart = () => ({
  type: types.GET_BRAND_START,
})
export const getBrandSuccess = payload => ({
  type: types.GET_BRAND_SUCCESS,
  payload: payload,
})

export const getBrandFailure = error => ({
  type: types.GET_BRAND_FAILURE,
  payload: error,
})
export const getBrandReset = () => ({
  type: types.GET_BRAND_RESET,
})

//Model

export const getModelStart = payload => ({
  type: types.GET_MODEL_START,
  payload: payload,
})
export const getModelSuccess = payload => ({
  type: types.GET_MODEL_SUCCESS,
  payload: payload,
})

export const getModelFailure = error => ({
  type: types.GET_MODEL_FAILURE,
  payload: error,
})
export const getModelReset = () => ({
  type: types.GET_MODEL_RESET,
})

export const getPolicyReportStart = payload => ({
  type: types.GET_POLICYREPORT_START,
  payload,
})

export const getPolicyReportSuccess = payload => ({
  type: types.GET_POLICYREPORT_SUCCESS,
  payload,
})

export const getPolicyReportFail = payload => ({
  type: types.GET_POLICYREPORT_FAIL,
  payload,
})

export const getReferecesStart = payload => ({
  type: types.GET_REFERENCES_START,
  payload,
})

export const getReferecesSuccess = payload => ({
  type: types.GET_REFERENCES_SUCCESS,
  payload,
})

export const getReferecesFail = payload => ({
  type: types.GET_REFERENCES_FAIL,
  payload,
})

export const policyErrorReset = () => ({
  type: types.POLICY_ERROR_RESET,
})

// Duplicates Policy number

export const checkPolicyNumberStart = payload => ({
  type: types.CHECK_POLICY_NUMBER_START,
  payload,
})
export const checkPolicyNumberSuccess = payload => ({
  type: types.CHECK_POLICY_NUMBER_SUCCESS,
  payload,
})
export const checkPolicyNumberFailure = error => ({
  type: types.CHECK_POLICY_NUMBER_FAIL,
  payload: error,
})
export const checkPolicyNumberReset = () => ({
  type: types.CHECK_POLICY_NUMBER_RESET,
})


// Vehicle Make and Model

export const AddVehicleMakeModelStart = payload => ({
  type: types.ADD_MAKE_MODEL_START,
  payload,
})
export const AddVehicleMakeModelSuccess = payload => ({
  type: types.ADD_MAKE_MODEL_SUCCESS,
  payload,
})
export const AddVehicleMakeModelFailure = error => ({
  type: types.ADD_MAKE_MODEL_FAILURE,
  payload: error,
})
export const AddVehicleMakeModelReset = () => ({
  type: types.ADD_MAKE_MODEL_RESET,
})


// Delete Policie



export const deletePolicyStart = payload => {
  return {
    type: types.DELETE_POLICY_START,
    payload,
  }
}

export const deletePolicySuccess = payload => {
  return {
    type: types.DELETE_POLICY_SUCCESS,
    payload,
  }
}

export const deletePolicyFailure = error => ({
  type: types.DELETE_POLICY_FAILURE,
  payload: error,
})

export const deletePolicyReset = () => ({
  type: types.DELETE_POLICY_RESET,
})

export const reqPolicyReport = (payload) => ({
  type: types.REQ_POLICY_REPORT,
  payload
})

export const reqPolicyReportSuccess = (payload) => ({
  type: types.REQ_POLICY_REPORT_SUCCESS,
  payload
})

export const reqPolicyReportFailed = (payload) => ({
  type: types.REQ_POLICY_REPORT_FAILED,
  payload
})

export const getpolicyReportStatus = payload => ({
  type: types.POLICY_REPORT_STATUS,
  payload
})

export const getpolicyReportStatusSuccess = payload => ({
  type: types.POLICY_REPORT_STATUS_SUCCESS,
  payload
})

export const getpolicyReportStatusFailed = payload => ({
  type: types.POLICY_REPORT_STATUS_FAILED,
  payload
})

export const downloadPolicyReport = payload => ({
  type: types.DOWNLOAD_POLICY_REPORT,
  payload
})

export const downloadPolicyReportSuccess = payload => ({
  type: types.DOWNLOAD_POLICY_REPORT_SUCCESS,
  payload
})

export const downloadPolicyReportFailed = payload => ({
  type: types.DOWNLOAD_POLICY_REPORT_FAILED,
  payload
})

export const resetPolicyReportDownload = () => ({
  type: types.RESET_POLICY_REPORT_DOWNLOAD
})


export const getAllPolicyReports = () => ({
  type: types.GET_ALL_POLICY_REPORTS
})

export const getAllPolicyReportsSuccess = (payload) => ({
  type: types.GET_ALL_POLICY_REPORTS_SUCCESS,
  payload
})

export const getAllPolicyReportsFailed = (payload) => ({
  type: types.GET_ALL_POLICY_REPORTS_FAILED,
  payload
})

export const getCommissionPermission = () => ({
  type: types.GET_COMMISSION_PERMISSION
})
export const getCommissionPermissionSuccess = (payload) => ({
  type: types.GET_COMMISSION_PERMISSION_SUCCESS,
  payload
})
export const getCommissionPermissionFailed = (payload) => ({
  type: types.GET_COMMISSION_PERMISSION_FAILED,
  payload
})

export const uploadFileStart = payload => ({
  type: types.UPLOAD_POLICY_FILE_START,
  payload,
})

export const uploadFileSuccess = payload => ({
  type: types.UPLOAD_POLICY_FILE_SUCCESS,
  payload
})

export const uploadFileFail = payload =>({
  type: types.UPLOAD_POLICY_FILE_FAIL,
  payload
})

export const getUploadedFileStart = payload =>({
  type: types.GET_UPLOADED_POLICY_FILE_START,
  payload
})

export const getUploadedFileSuccess = payload =>({
  type: types.GET_UPLOADED_POLICY_FILE_SUCCESS,
  payload
})

export const getUploadedFileFailure = payload =>({
  type: types.GET_UPLOADED_POLICY_FILE_FAILURE,
  payload
})


export const getUploadedFileReset = () =>({
  type: types.GET_UPLOADED_POLICY_FILE_RESET
})


export const deleteFileStart = id => ({
  type: types.DELETE_POLICY_FILE_START,
  payload: id,
})

export const deleteFileSuccess = payload => ({
  type: types.DELETE_POLICY_FILE_SUCCESS,
  payload,
})

export const deleteFileFailure = error => ({
  type: types.DELETE_POLICY_FILE_FAILURE,
  payload: error,
})

export const deleteFileReset = () => ({
  type: types.DELETE_POLICY_FILE_RESET,
})

export const editPolicyFiles = payload =>({
  type: types.EDIT_POLICY_FILES,
  payload
})

export const editPolicyFilesSuccess = payload =>({
  type: types.EDIT_POLICY_FILES_SUCCESS,
  payload
})

export const editPolicyFilesFailed = payload =>({
  type: types.EDIT_POLICY_FILES_FAILED,
  payload
})

export const uploadPolicyPdfStart = data => ({
  type: types.UPLOAD_POLICY_PDF_START,
  payload: data,
})

export const uploadPolicyPdfSuccess = data => ({
  type: types.UPLOAD_POLICY_PDF_SUCCESS,
  payload: data,
})

export const uploadPolicyPdfError = error => ({
  type: types.UPLOAD_POLICY_PDF_ERROR,
  payload: error,
})

export const uploadPolicyPdfReset = () => ({
  type: types.UPLOAD_POLICY_PDF_RESET,
})

export const autoFillStart = (payload) => ({
  type: "AUTO_FILL_START",
  payload
})

export const autoFillSuccess = (payload) => ({
  type: "AUTO_FILL_SUCCESS",
  payload
})

export const autoFillFail = (error) => ({
  type: "AUTO_FILL_FAIL",
  payload: error
})

export const reqIRDAPolicyReport = payload => ({
  type: types.REQ_IRDA_POLICY_REPORT,
  payload
});

export const reqIRDAPolicyReportSuccess = payload => ({
  type: types.REQ_IRDA_POLICY_REPORT_SUCCESS,
  payload
});

export const reqIRDAPolicyReportFail = error => ({
  type: types.REQ_IRDA_POLICY_REPORT_FAIL,
  payload: error
});

export const movePolicyStagingStart = payload => ({
    type: types.MOVE_POLICY_STAGING_START,
    payload
});

export const movePolicyStagingSuccess = data => ({
    type: types.MOVE_POLICY_STAGING_SUCCESS,
    payload: data
});

export const movePolicyStagingError = error => ({
    type: types.MOVE_POLICY_STAGING_ERROR,
    payload: error
});

export const movePolicyStagingReset = () => ({
    type: types.MOVE_POLICY_STAGING_RESET
});